@if (useFastIconType && item.type !== 'icon') {
    <vn-menu-item [item]="item" [displayMode]="MenuDisplayMode.FastIcon" [section]="MenuSection.Header" [noClass]="true" />
} @else {
    <vn-menu-item [item]="item" [displayMode]="MenuDisplayMode.Icon" [section]="MenuSection.Header" iconClass="ui-icon ui-icon-size-xl" />
}
